import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import CardSpacer from "@saleor/components/CardSpacer";
import CardTitle from "@saleor/components/CardTitle";
import Date from "@saleor/components/Date";
import FormSpacer from "@saleor/components/FormSpacer";
import Hr from "@saleor/components/Hr";
import Money from "@saleor/components/Money";
import Percent from "@saleor/components/Percent";
import Skeleton from "@saleor/components/Skeleton";
import { commonMessages } from "@saleor/intl";
import { dateTimePhTimeZone } from "@saleor/utils/smop/timeZonePH";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { maybe } from "../../../misc";
import { SaleType } from "../../../types/globalTypes";
import { SaleDetails_sale } from "../../types/SaleDetails";
export interface SaleSummaryProps {
  defaultCurrency: string;
  sale: SaleDetails_sale;
}

const SaleSummary: React.FC<SaleSummaryProps> = ({ defaultCurrency, sale }) => {
  const intl = useIntl();

  return (
    <Card>
      <CardTitle title={intl.formatMessage(commonMessages.summary)} />
      <CardContent>
        <Typography variant="caption">
          <FormattedMessage defaultMessage="Name" description="sale name" />
        </Typography>
        <Typography id="saleNameValue">
          {maybe<React.ReactNode>(() => sale.name, <Skeleton />)}
        </Typography>
        <FormSpacer />

        <Typography variant="caption">
          <FormattedMessage defaultMessage="Value" description="sale value" />
        </Typography>
        <Typography id="saleValueValue">
          {maybe<React.ReactNode>(
            () =>
              sale.type === SaleType.FIXED ? (
                <Money
                  money={{
                    amount: sale.value,
                    currency: defaultCurrency
                  }}
                />
              ) : (
                <Percent amount={sale.value} />
              ),
            <Skeleton />
          )}
        </Typography>

        <CardSpacer />
        <Hr />
        <CardSpacer />

        <Typography variant="caption">
          <FormattedMessage {...commonMessages.startDate} />
        </Typography>
        <Typography id="saleStartValue">
          {maybe<React.ReactNode>(
            () => (
              <Date date={dateTimePhTimeZone(sale.startDate).date} plain />
            ),
            <Skeleton />
          )}
        </Typography>
        <FormSpacer />

        <Typography variant="caption">
          <FormattedMessage {...commonMessages.endDate} />
        </Typography>
        <Typography id="saleEndValue">
          {maybe<React.ReactNode>(
            () =>
              sale.endDate === null ? (
                "-"
              ) : (
                <Date date={dateTimePhTimeZone(sale.endDate).date} plain />
              ),
            <Skeleton />
          )}
        </Typography>
        <FormSpacer />

        <Typography variant="caption">
          <FormattedMessage
            defaultMessage="Discount Status"
            description="voucher value requirement"
          />
        </Typography>
        <Typography id="saleStatusValue">
          {maybe<React.ReactNode>(
            () => (sale?.status === null ? "-" : sale?.status),
            <Skeleton />
          )}
        </Typography>
      </CardContent>
    </Card>
  );
};
SaleSummary.displayName = "SaleSummary";
export default SaleSummary;
